import iconHome from '../../../assets/icons/home.svg'

const DefaultStore = {
    showMenu: false,
    activeItem: 0,
    items: [
        {
            text: "Dashboard",
            icon: iconHome,
            subItems: []
        },
        {
            text: "Content",
            icon: iconHome,
            subItems: [
                {
                    url: "/content/tour-packages",
                    text: "Tour Packages"
                },
                {
                    url: "/content/hotels",
                    text: "Hotels"
                },
                {
                    url: "/content/flight-offers",
                    text: "Flight Offers"
                },
                {
                    url: "/content/visa-packages",
                    text: "Visa Packages"
                }
            ]
        },
        {
            text: "Settings",
            icon: iconHome,
            subItems: [
                {
                    url: "/settings/profile",
                    text: "Profile"
                },
                {
                    url: "/settings/change-password",
                    text: "Change Password"
                }
            ]
        }
    ]
}

export default DefaultStore
